import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "checkmark" }

import { ref, computed } from 'vue'
	import {useGlobalStore} from "@/stores/GlobalStore";

	
export default /*@__PURE__*/_defineComponent({
  __name: 'Autorefresh',
  setup(__props) {

	const globalStore = useGlobalStore();
	//const activeText = ref("Aktualisierung An");
	//const inactiveText = ref("Aktualisierung Aus");
	const activeIcon = ref("icon-nachladen");
	const inactiveIcon = ref("icon-nachladen");
	const autoRefreshActive = ref(globalStore.refreshIsActive);

	const statusIcon = computed(() => {
		if(autoRefreshActive.value) {
			return activeIcon.value;
		} else {
			return inactiveIcon.value;
		}
	});

	// const statusText = computed(() => {
	// 	if(autoRefreshActive.value) {
	// 		return activeText.value;
	// 	} else {
	// 		return inactiveText.value;
	// 	}
	// });

	const toggleRefresh = () => {
		autoRefreshActive.value = !autoRefreshActive.value;
	}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["autoRefresh", { active: _unref(globalStore).refreshIsActive }]),
    onClick: toggleRefresh
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", {
        class: _normalizeClass(statusIcon.value)
      }, null, 2)
    ])
  ], 2))
}
}

})